import InternalAuthStream from "@irati/auth-internal/streams/auth"
import loginService from "@irati/auth/services/login"

export default function stopAllStreams() {
  loginService.logout()
  InternalAuthStream.stop()
}
